import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { fmtNum } from '@/lib/recuentos';

export const EnviarDialog = ({ open, onOpenChange, validacion, onConfirm, sending }) => {
  const noContados = validacion?.no_contados || [];
  const alertas = validacion?.alertas || [];
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg max-h-[85vh] overflow-y-auto" data-testid="enviar-recuento-dialog">
        <DialogHeader><DialogTitle>Enviar recuento</DialogTitle></DialogHeader>
        <div className="space-y-4 text-sm">
          {noContados.length > 0 && (
            <div className="rounded-lg bg-amber-50 border border-amber-200 p-3" data-testid="enviar-no-contados">
              <p className="font-semibold text-amber-800 mb-1">Quedan {noContados.length} ingredientes sin contar (no se incluirán en el Excel):</p>
              <ul className="list-disc pl-5 text-amber-800 max-h-32 overflow-y-auto">
                {noContados.map((n) => <li key={n}>{n}</li>)}
              </ul>
            </div>
          )}
          {alertas.length > 0 && (
            <div className="rounded-lg bg-red-50 border border-red-200 p-3" data-testid="enviar-alertas">
              <p className="font-semibold text-red-700 mb-1 flex items-center gap-1"><AlertTriangle className="w-4 h-4" /> Revisa estas cantidades (muy distintas al recuento anterior):</p>
              <ul className="space-y-1 text-red-700">
                {alertas.map((a) => (
                  <li key={a.nombre}><b>{a.nombre}</b>: {fmtNum(a.cantidad_actual)} {a.unidad} (antes {fmtNum(a.cantidad_anterior)})</li>
                ))}
              </ul>
              <p className="text-xs text-red-600 mt-2">¿Puede ser un error de unidad? (ej. gramos en vez de kg)</p>
            </div>
          )}
          {noContados.length === 0 && alertas.length === 0 && <p className="text-slate-600">Todo contado. ¿Confirmas el envío?</p>}
          <p className="text-xs text-slate-500">Una vez enviado, solo el administrador podrá reabrirlo o corregirlo.</p>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="enviar-cancelar-btn">Volver a revisar</Button>
          <Button onClick={onConfirm} disabled={sending} className="bg-orange-500 hover:bg-orange-600" data-testid="enviar-confirmar-btn">
            {sending ? 'Enviando...' : noContados.length || alertas.length ? 'Enviar de todas formas' : 'Enviar'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
